import Vue from 'vue'
import Pop from './pop'

const PopCtor = Vue.extend(Pop)

let instance

const SelectRole = function({ showRole = true, bindGames, title = '' } = {}) {
  if (Vue.prototype.$isServer) return Promise.reject(new Error('isServer'))

  instance = new PopCtor({
    propsData: {
      showRole,
      bindGames: bindGames || [],
      title
    }
  })

  instance.$mount()
  document.body.appendChild(instance.$el)

  return new Promise((resolve, reject) => {
    instance.$once('confirm', (data) => {
      resolve(data)
      instance.destroyElement()
    })
    instance.$once('cancel', () => {
      reject(new Error('cancel'))
      instance.destroyElement()
    })
  })
}

SelectRole.close = function() {
  instance.destroyElement()
}

export default SelectRole
